import type { ManualIndex } from "./types";

const screenPath = (url: string) => url.split("?")[0].split("/:")[0];

/** 現在のパスに screen_url が最長一致する節(`:id` 部分は前方一致)。 */
export function sectionFor(index: ManualIndex | undefined, pathname: string) {
  const matches = index?.modules.flatMap((m) => m.sections
    .filter((s) => s.screen_url && !s.heading_only &&
      (pathname === screenPath(s.screen_url) || pathname.startsWith(`${screenPath(s.screen_url)}/`)))
    .map((s) => ({ module: m.module, anchor: s.anchor, id: s.id, title: s.title, length: screenPath(s.screen_url!).length }))) ?? [];
  return matches.sort((a, b) => b.length - a.length)[0];
}

